module.exports = __webpack_public_path__ + "static/media/ic-edit.07406428.svg";